/* Narthex Motion — Scroll-Reveal (robust, ohne Observer-Lücken) */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = Array.prototype.slice.call(
    document.querySelectorAll('#MainContent .shopify-section')
  );
  if (sections.length < 2) return;

  sections.shift(); // Hero bleibt sofort sichtbar (LCP)
  sections.forEach(function (s) {
    s.classList.add('nx-reveal');
  });

  var pending = sections.slice();
  var ticking = false;

  function check() {
    ticking = false;
    var limit = window.innerHeight * 0.92;
    for (var i = pending.length - 1; i >= 0; i--) {
      if (pending[i].getBoundingClientRect().top < limit) {
        pending[i].classList.add('nx-in');
        pending.splice(i, 1);
      }
    }
    if (!pending.length) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(check);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  check();
})();
